module.exports = __webpack_public_path__ + "img/banner-1.d0a3f159.jpg";